/**
 * Form Registry - Maps form IDs to metadata
 *
 * Used by EditFormContainer to resolve which form to render.
 * Forms are rendered inline (not lazy-loaded) for simplicity in M4.
 */

import type { TabId } from '@/stores/aircraftCardStore'

export interface FormRegistryEntry {
  id: string
  title: string
  /** Whether the form is implemented or just a placeholder */
  available: boolean
  /** Tab to open in AircraftFullModal when user clicks "View Details" */
  defaultTab: TabId
}

export const FORM_REGISTRY: Record<string, FormRegistryEntry> = {
  'aircraft-details': {
    id: 'aircraft-details',
    title: 'Edit Aircraft Details',
    available: true,
    defaultTab: 'aircraft',
  },
  'aircraft-notes': {
    id: 'aircraft-notes',
    title: 'Edit Notes',
    available: true,
    defaultTab: 'aircraft',
  },
  'allocation-settings': {
    id: 'allocation-settings',
    title: 'Allocation Settings',
    available: true,
    defaultTab: 'aircraft',
  },
  'transient-stay': {
    id: 'transient-stay',
    title: 'Edit Transient Stay',
    available: true,
    defaultTab: 'financial',
  },
  'client-editor': {
    id: 'client-editor',
    title: 'Edit Client',
    available: true,
    defaultTab: 'client',
  },
}
